import React, { Component } from 'react';
import { bcg, title } from './ErrorBoundary.module.css';
import { element } from 'prop-types';

export default class ErrorBoundary extends Component {
  static propTypes = {
    children: element
  }

  state = {
    hasError: false
  }

  componentDidCatch() {
    this.setState({ hasError: true })
  }

  render() {
    const { hasError } = this.state
    const { children } = this.props

    if (hasError) {
      return (
        <div className={`${bcg}`}>
          <h1 className={`${title} title`}>There's an error occured.<br />Please refresh the page or come back later.</h1>
        </div>
      )
    }
    return children
  }
}